import type { MarketQuote } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";
import { cx } from "class-variance-authority";

interface Props {
  quote: MarketQuote;
}

export const MarketQuotePrice = ({ quote }: Props) => {
  useSignals();
  return (
    <span
      className={cx(
        "text-right",
        quote.priceUp.value && "animate-salary-flash-up text-success-200",
        quote.priceDown.value && "animate-salary-flash-down text-danger-200",
      )}
    >
      {quote.price}
    </span>
  );
};
